<template>
    <section class="left_menu">
        <nav class="left_gnb">
            <ul class="depth_01">
                <li
                    :class="{
                        active:
                            route.path === '/memberList' ||
                            route.path === '/adminList' ||
                            route.path === '/letterAgreeList' ||
                            route.path.startsWith('/action') ||
                            state.isShowSub1,
                    }"
                    @mouseover="state.isShowSub1 = true"
                    @mouseleave="state.isShowSub1 = false"
                    v-if="hasRole('action')"
                >
                    <div>
                        <span class="menu_icon"><img src="img/menu_user.png" alt="" /></span>
                        회원/관리자 관리
                    </div>
                    <ul
                        class="depth_02"
                        v-if="
                            route.path === '/memberList' ||
                            route.path === '/adminList' ||
                            route.path === '/letterAgreeList' ||
                            route.path.startsWith('/action') ||
                            state.isShowSub1
                        "
                    >
                        <li :class="{ active: route.path === '/memberList' }">
                            <router-link to="/memberList" v-if="hasRole()">회원관리</router-link>
                        </li>
                        <li :class="{ active: route.path === '/adminList' }">
                            <router-link to="/adminList" v-if="hasRole()">관리자관리</router-link>
                        </li>
                        <li :class="{ active: route.path === '/letterAgreeList' }">
                            <router-link to="/letterAgreeList" v-if="hasRole()">뉴스레터 수신동의</router-link>
                        </li>
                        <li :class="{ active: route.path.startsWith('/action') }">
                            <router-link to="/action/group" v-if="hasRole('action')">액션 시민 그룹</router-link>
                        </li>
                    </ul>
                </li>
                <li
                    :class="{
                        active:
                            route.path === '/mainPage' ||
                            route.path === '/reportList' ||
                            route.path === '/activityList' ||
                            route.path === '/activityManageList' ||
                            route.path === '/activityStateList' ||
                            route.path === '/eventList' ||
                            route.path === '/newsList' ||
                            route.path === '/archiveList' ||
                            route.path === '/qnaList' ||
                            state.isShowSub2,
                    }"
                    @mouseover="state.isShowSub2 = true"
                    @mouseleave="state.isShowSub2 = false"
                >
                    <div>
                        <span class="menu_icon"><img src="img/menu_site_setting.png" alt="" /></span>
                        사이트 관리
                    </div>
                    <ul
                        class="depth_02"
                        v-if="
                            route.path === '/mainPage' ||
                            route.path === '/reportList' ||
                            route.path === '/activityList' ||
                            route.path === '/activityManageList' ||
                            route.path === '/activityStateList' ||
                            route.path === '/eventList' ||
                            route.path === '/newsList' ||
                            route.path === '/archiveList' ||
                            route.path === '/qnaList' ||
                            state.isShowSub2
                        "
                    >
                        <li :class="{ active: route.path === '/mainPage' }" v-if="hasRole()"><router-link to="/mainPage">메인화면</router-link></li>
                        <li :class="{ active: route.path === '/reportList' }" v-if="hasRole('report')">
                            <router-link to="/reportList">시민제보창</router-link>
                        </li>
                        <!-- <li :class="{ active: route.path === '/activityList' }" v-if="hasRole('board1')">
                            <router-link to="/activityList">시민참여활동</router-link>
                        </li> -->
                        <li :class="{ active: route.path === '/activityManageList' }" v-if="hasRole('board2')">
                            <router-link to="/activityManageList">시민활동관리</router-link>
                        </li>
                        <!-- <li :class="{ active: route.path === '/activityStateList' }" v-if="hasRole('board2')">
                            <router-link to="/activityStateList">액션활동관리</router-link>
                        </li> -->
                        <li :class="{ active: route.path === '/eventList' }" v-if="hasRole('event')">
                            <router-link to="/eventList">캠페인·이벤트</router-link>
                        </li>
                        <li :class="{ active: route.path === '/newsList' }" v-if="hasRole('news')">
                            <router-link to="/newsList">감시소식</router-link>
                        </li>
                        <li :class="{ active: route.path === '/archiveList' }" v-if="hasRole('news')">
                            <router-link to="/archiveList">자료집</router-link>
                        </li>
                        <li :class="{ active: route.path === '/qnaList' }"><router-link to="/qnaList">1:1 문의</router-link></li>
                    </ul>
                </li>
                <li :class="{ active: route.path === '/statistics' }">
                    <div>
                        <router-link to="/statistics">
                            <span class="menu_icon"><img src="img/menu_graph.png" alt="" /></span>
                            통계
                        </router-link>
                    </div>
                </li>
            </ul>
        </nav>
        <div class="utility_wrap">
            <div><a :href="state.userSiteUrl" target="_blank">반성매매 시민참여 플랫폼</a></div>
            <div>{{ user.userInfo.name }} 님</div>
            <div><button @click="logout" type="button">로그아웃</button></div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts">
    import {
        apiService,
        onMounted,
        reactive,
        router,
        userStore,
        returnCode,
        globalStore,
        watch,
        types,
        useRoute,
        ref,
        onUnmounted,
        getMessageByCode,
        ModalDefault,
    } from "@/BaseComponent";

    export default {
        components: { ModalDefault },
        setup() {
            const user = userStore();
            const route = useRoute();

            const userInfo = reactive({
                info: {} as any,
                password: "" as string,
                password_ck: "" as string,
                name: user.userInfo?.name as string,
                id: user.userInfo?.id as string,
            });
            const state = reactive({
                searchDate: [] as any,
                userMenu: false,
                settingMenu: false,
                isModalOpen: false,
                isUserModal: false,
                isKeywordModal: false,
                isHelperModal: false,
                position: [] as any,
                dept: [] as any,
                isLogin: false as boolean,
                isFloat: false as boolean,

                menuOverFlag: false as boolean,
                headerClass: [] as Array<string>,
                isScroll: false as boolean,

                isShowSub1: false as boolean,
                isShowSub2: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,
            });

            const modal = reactive({
                title: "",
                customClass: {
                    wrap: [] as Array<string>,
                    button: [] as Array<string>,
                },
                list: [] as any,
                fields: [] as any,
                cancel: "",
                confirm: "",
                type: "nation",
                actionCode: 0 as number,
                isBtn: true as boolean,
            });

            const scrollY = ref(0);

            onMounted(async () => {
                checkLogin();
                window.addEventListener("scroll", handleScroll);

                state.headerClass = route.meta.headerClass as string[];

                me();
            });

            onUnmounted(() => {
                window.removeEventListener("scroll", handleScroll);
            });

            watch(
                () => user.accessToken,
                () => {
                    checkLogin();
                },
            );

            const handleScroll = () => {
                scrollY.value = window.scrollY;

                if (scrollY.value >= 100) {
                    state.isScroll = true;
                } else {
                    state.isScroll = false;
                }
            };

            const checkLogin = () => {
                if (user.isLogin() && user.userInfo.isAdmin) {
                    state.isLogin = true;
                } else {
                    user.$reset();
                    router.replace("/login");
                    state.isLogin = false;
                }
            };

            const handleOutsideClick = () => {
                state.userMenu = false;
            };

            const handleOutsideClick2 = () => {
                state.settingMenu = false;
            };

            const me = async () => {
                let res: types.ResUserInfo = await apiService.auth.mypageMe();
                if (res.returnCode === 0) {
                    user.setInfo({
                        id: res.data.memberVO.id,
                        idx: res.data.memberVO.idx,
                        name: res.data.memberVO.name,
                        isAdmin: res.data.memberVO.gubun !== 3,
                        gubun: res.data.memberVO.gubun,
                    });
                    user.setRole(res.data.roleVO);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const logout = async () => {
                if (user && user.accessToken != null && user.accessToken != "") {
                    await apiService.auth.logout();
                }
            };

            const openMenu = (menuIdx: number) => {
                switch (menuIdx) {
                    case 0:
                        state.userMenu = !state.userMenu;
                        state.settingMenu = false;
                        break;
                    case 1:
                        state.settingMenu = !state.settingMenu;
                        state.userMenu = false;
                        break;
                }
            };

            const hasRole = (param?: string) => {
                let keyArr: null | Array<string> = null;
                switch (param) {
                    case "report":
                        keyArr = ["role_ad", "role_area"];
                        break;
                    case "board1":
                        keyArr = ["role_activity", "role_event", "role_news"];
                        break;

                    case "board2":
                        keyArr = ["role_activity", "role_suggest"];
                        break;

                    case "event":
                        keyArr = ["role_event"];
                        break;

                    case "news":
                        keyArr = ["role_news"];
                        break;

                    case "action":
                        keyArr = ["role_activity"];
                        break;
                }

                if (user.userInfo.gubun === 1) return true;
                else if (user.userInfo.gubun === 2) {
                    if (keyArr !== null && user.roles && user.roles.some((role: any) => keyArr!.includes(role.key))) {
                        return true;
                    }
                }

                return false;
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const callBackModal = async (param: any) => {};

            return {
                state,
                route,
                userInfo,
                modal,
                openMenu,
                logout,
                router,
                handleOutsideClick,
                handleOutsideClick2,
                hasRole,
                user,
                closeModal,
                callBackModal,
            };
        },
    };
</script>
<style>
    .left_menu nav ul.depth_01 > li span {
        margin-right: 5px !important;
    }
</style>
